import { ConnectedAudiologistChainNumberStatus, GetAudiologistsOfSupplierParams } from "@bvhi/backend-api";
import { Button, BVHISelect, Card, CardContent, CardHeader, Grid, TextField } from "@bvhi/ui-base";
import { ClearIcon } from "@bvhi/ui-icons";
import isEqual from "lodash/isEqual";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { defaultAudiologistFilter } from "./default-audiologist-filter";

interface Props {
  filter: GetAudiologistsOfSupplierParams;
  onChange: ({ key, value }: { key: string; value: string | string[] }) => void;
  onReset: () => void;
}

export const AudiologistsFilterCard = ({ filter, onChange, onReset }: Props) => {
  const { t } = useTranslation(["audiologists", "common", "userstatus"]);

  const isResetDisabled = useMemo(() => {
    return isEqual(filter, defaultAudiologistFilter);
  }, [filter]);

  return (
    <Card>
      <CardHeader
        restrictContentWidth={false}
        title={t("audiologists:audiologists.card.filter.title")}
        action={
          <Button color="secondary" disabled={isResetDisabled} endIcon={<ClearIcon />} onClick={onReset} variant="text">
            {t("common:button.reset.filter")}
          </Button>
        }
      />
      <CardContent>
        <Grid container pb={2} spacing={2}>
          <Grid xs={8}>
            <TextField
              fullWidth
              label={t("audiologists:audiologists.card.filter.searchtext.label")}
              placeholder={t("audiologists:audiologists.card.filter.searchtext.placeholer")}
              value={filter.searchString ?? ""}
              onChange={(e) => {
                onChange({ key: "searchString", value: e.target.value });
              }}
            />
          </Grid>
          <Grid xs={4}>
            <BVHISelect
              displayEmpty
              fullWidth
              label={t("audiologists:audiologists.card.filter.status.label")}
              multiple
              showReset
              value={filter.statuses ?? []}
              handleChange={(value) => {
                onChange({ key: "statuses", value: value });
              }}
              handleReset={() => {
                onChange({ key: "statuses", value: [] });
              }}
              items={[
                {
                  key: ConnectedAudiologistChainNumberStatus.ACTIVE,
                  value: ConnectedAudiologistChainNumberStatus.ACTIVE,
                  label: t("userstatus:ACTIVE"),
                },
                {
                  key: ConnectedAudiologistChainNumberStatus.INACTIVE,
                  value: ConnectedAudiologistChainNumberStatus.INACTIVE,
                  label: t("userstatus:INACTIVE"),
                },
              ]}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
